import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import OrderButton from './OrderButton';

export function getClickHandler(spec) {
  const { item, sort, order, setSorting } = spec;
  const valueFromItem = item.get('value');
  let orderFromItem = order;

  if (sort === valueFromItem) {
    orderFromItem = orderFromItem === 'desc' ? 'asc' : 'desc';
  } else if (valueFromItem === 'IDE.NUMREF') {
    orderFromItem = item.get('order');
  }

  return () => {
    setSorting(valueFromItem, orderFromItem);
  };
}

export default function LeftOrderButtons(props) {
  const { sort, item, order, size, setSorting, isTgitemsContext } = props;

  const value = item.get('value');

  if (sort !== value) {
    return null;
  }

  return (
    <span className="result-toolbar-sort-by-left-order-buttons">
      <OrderButton
        icon="down"
        item={item}
        order={order}
        setSorting={setSorting}
        buttonOrderValue="desc"
        size={size}
        isTgitemsContext={isTgitemsContext}
      />
      <OrderButton
        icon="up"
        item={item}
        order={order}
        setSorting={setSorting}
        buttonOrderValue="asc"
        isTgitemsContext={isTgitemsContext}
        size={size}
      />
    </span>
  );
}

LeftOrderButtons.propTypes = {
  sort: PropTypes.string.isRequired,
  item: PropTypes.instanceOf(Map).isRequired,
  order: PropTypes.string.isRequired,
  setSorting: PropTypes.func.isRequired,
  isTgitemsContext: PropTypes.bool.isRequired,
  size: PropTypes.string,
};
